import { GridService, IGridService } from '../shared/grid/grid.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Jurisdiction } from '../models/Jurisdiction.model';
import { JurisdictionLookup } from '../models/jurisdictionLookup.model';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionService extends GridService<Jurisdiction> {

    constructor(http: HttpClient) {
        super('Jurisdiction', http);
    }

    override getAll(filterBy: string = ''): Observable<JurisdictionLookup[]> {
        return this.http.get<JurisdictionLookup[]>(this.getApiUrl(`${this.controllerName}/GetAll?filterBy=${filterBy}`));
    }

    getByOrgLevel(organizationLevelId: string): Observable<JurisdictionLookup[]> {
        return this.http.get<JurisdictionLookup[]>(this.getApiUrl(`${this.controllerName}/GetByOrgLevel?organizationLevelId=${organizationLevelId}`));
    }
}

